import './sentry'
import 'react-app-polyfill/ie9.js'
import React from 'react'
import ReactDOM from 'react-dom'
import {ApolloProvider} from 'react-apollo'
import {BrowserRouter} from 'react-router-dom'
import * as serviceWorker from './serviceWorker.js'
import {getApolloClient} from './graphql/utils.js'
import './common/utils/polyfill.js'
import {config} from './config'

import AppProvider from './AppProvider'
import './index.css'
import './checkout.css'
import {ErrorBoundaryWrapper} from './components/ErrorBoundaryWrapper'

// Global error handler to catch and suppress removeChild errors from third-party scripts
// This prevents errors from GTM and other third-party scripts from breaking the UI
// Set up immediately to catch errors that occur during page load
(function() {
  const removeChildErrorPattern = /Failed to execute ['"]removeChild['"] on ['"]Node['"]/i

  // Catch synchronous errors
  window.addEventListener('error', (event) => {
    const errorMessage = event.error?.message || event.message || ''
    if (typeof errorMessage === 'string' && removeChildErrorPattern.test(errorMessage)) {
      // eslint-disable-next-line no-console
      console.warn('Suppressed removeChild error from third-party script:', errorMessage)
      event.preventDefault()
      event.stopPropagation()
      return false
    }
  }, true)

  // Catch unhandled promise rejections
  window.addEventListener('unhandledrejection', (event) => {
    const errorMessage = event.reason?.message || String(event.reason || '')
    if (typeof errorMessage === 'string' && removeChildErrorPattern.test(errorMessage)) {
      // eslint-disable-next-line no-console
      console.warn('Suppressed removeChild error from promise rejection:', errorMessage)
      event.preventDefault()
    }
  })

  // Override console.error to catch errors that might be logged but not thrown
  // eslint-disable-next-line no-console
  const originalConsoleError = console.error
  // eslint-disable-next-line no-console
  console.error = function(...args) {
    const errorMessage = args.join(' ')
    if (typeof errorMessage === 'string' && removeChildErrorPattern.test(errorMessage)) {
      // eslint-disable-next-line no-console
      console.warn('Suppressed removeChild error from console.error:', errorMessage)
      return
    }
    originalConsoleError.apply(console, args)
  }
})()

const apolloClient = getApolloClient()

ReactDOM.render(
  <ErrorBoundaryWrapper>
    <ApolloProvider client={apolloClient}>
      <BrowserRouter basename={config.vnAccess ? '/app' : undefined}>
        <AppProvider />
      </BrowserRouter>
    </ApolloProvider>
  </ErrorBoundaryWrapper>,
  document.getElementById('root'))

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister()
